"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSiteSystemsProductsError = exports.listSiteSystemsProducts = exports.addProductsToSystems = exports.createSiteError = exports.closeAddSiteModal = exports.openAddSiteModal = exports.createSiteSuccess = exports.createSite = exports.getSitesError = exports.getSitesSuccess = exports.getSites = exports.sitesSlices = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    siteList: [],
    isSiteListLoading: false,
    hasErrorLoadinglist: false,
    isAddSiteModalOpen: false,
    isCreatingSite: false,
    createSitesSuccessMessage: "",
    createSiteErrorMessage: "",
    siteToast: { isOpen: false, message: "", status: undefined },
};
exports.sitesSlices = (0, toolkit_1.createSlice)({
    name: "sites",
    initialState,
    reducers: {
        getSites: (state) => {
            state.isSiteListLoading = true;
        },
        getSitesSuccess: (state, action) => {
            state.isSiteListLoading = false;
            state.siteList = action.payload;
        },
        getSitesError: (state) => {
            state.isSiteListLoading = false;
            state.hasErrorLoadinglist = true;
        },
        createSite: (state) => {
            state.isCreatingSite = true;
            (state.createSitesSuccessMessage = ""),
                (state.createSiteErrorMessage = "");
        },
        createSiteSuccess: (state) => {
            state.isCreatingSite = false;
            state.createSitesSuccessMessage = "Site created successfully";
        },
        createSiteError: (state) => {
            state.isCreatingSite = false;
            state.createSitesSuccessMessage = "Error creating site";
        },
        openAddSiteModal: (state) => {
            state.isAddSiteModalOpen = true;
        },
        closeAddSiteModal: (state) => {
            state.isAddSiteModalOpen = false;
        },
        openSiteToast: (state, action) => {
            state.siteToast.isOpen = true;
            state.siteToast.status = action.payload.status;
            state.siteToast.message = action.payload.message;
        },
        listSiteSystemsProducts: (state, action) => {
            const affectedSite = state.siteList.find((site) => site.id === action.payload.siteId);
            const affectedSystem = affectedSite?.systemsList.find((system) => system.id === action.payload.systemId);
            if (affectedSystem) {
                affectedSystem.isLoading = true;
            }
        },
        listSiteSystemsProductsError: (state, action) => {
            const affectedSite = state.siteList.find((site) => site.id === action.payload.siteId);
            const affectedSystem = affectedSite?.systemsList.find((system) => system.id === action.payload.systemId);
            if (affectedSystem) {
                affectedSystem.errorMessage = "Error loading products";
                affectedSystem.isLoading = false;
            }
        },
        addProductsToSystems: (state, action) => {
            const siteToBeUpdated = state.siteList.find((site) => site.id === action.payload.siteId);
            const systemToBeUpdated = siteToBeUpdated?.systemsList.find((system) => system.id === action.payload.systemId);
            if (systemToBeUpdated) {
                systemToBeUpdated.products = action.payload.products;
                systemToBeUpdated.isLoading = false;
            }
        },
    },
});
_a = exports.sitesSlices.actions, exports.getSites = _a.getSites, exports.getSitesSuccess = _a.getSitesSuccess, exports.getSitesError = _a.getSitesError, exports.createSite = _a.createSite, exports.createSiteSuccess = _a.createSiteSuccess, exports.openAddSiteModal = _a.openAddSiteModal, exports.closeAddSiteModal = _a.closeAddSiteModal, exports.createSiteError = _a.createSiteError, exports.addProductsToSystems = _a.addProductsToSystems, exports.listSiteSystemsProducts = _a.listSiteSystemsProducts, exports.listSiteSystemsProductsError = _a.listSiteSystemsProductsError;
exports.default = exports.sitesSlices.reducer;
